import React from 'react';
import { ChevronDown, ChevronUp, UserCheck } from 'lucide-react';
import Select from '../../../components/ui/Select';

const InvestigatorAssignment = ({ expanded, onToggle, formData, setFormData }) => {
  const investigators = [
    { id: 'auto', name: 'Auto-assign based on incident type and location' },
    { id: 'john', name: 'John Smith - Senior Safety Investigator' },
    { id: 'sarah', name: 'Sarah Johnson - Environmental Health & Safety Manager' },
    { id: 'mike', name: 'Mike Wilson - Operations Safety Lead' },
    { id: 'emily', name: 'Emily Davis - Construction Safety Specialist' }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <UserCheck className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Investigation Assignment</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Assign Investigator
              </label>
              <Select
                value={formData?.assignedInvestigator}
                onChange={(e) => setFormData(prev => ({ ...prev, assignedInvestigator: e?.target?.value }))}
              >
                {investigators?.map((investigator) => (
                  <option key={investigator?.id} value={investigator?.id}>
                    {investigator?.name}
                  </option>
                ))}
              </Select>
              <p className="mt-1 text-xs text-gray-500">
                System will suggest appropriate investigator based on incident classification and location
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Priority Level
              </label>
              <Select
                value={formData?.priority}
                onChange={(e) => setFormData(prev => ({ ...prev, priority: e?.target?.value }))}
              >
                <option value="low">Low - Standard investigation timeline</option>
                <option value="medium">Medium - Expedited investigation required</option>
                <option value="high">High - Immediate investigation required</option>
                <option value="critical">Critical - Emergency investigation protocol</option>
              </Select>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <p className="text-sm font-medium text-blue-900 mb-1">
                Investigation Timeline
              </p>
              <p className="text-sm text-blue-800">
                Based on selected priority and classification, investigation should be completed within the specified regulatory timeframe. Investigator will be notified immediately upon submission.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvestigatorAssignment;